export const INVENTORY_PERMISSIONS = {
  read: 'Inventory.Read',
  write: 'Inventory.Write',
} as const;
